import clsx from 'clsx';
import React from 'react';

import {
  useCurrentUser,
  useSubscribeToNewsletter,
  useUnsubscribeFromNewsletter,
  useUpdateEmailSettings,
} from '../../../../hooks';
import { subscribe_path, upgrade_subscription_path } from '../../../../routes';
import { getImgxSrc } from '../../../../utils/images';
import styles from './styles.module.scss';

const PRO_OFFER_CODE = 'pro-disc25';

interface EmailSettingOptionProps {
  slug: string;
  newsletterId?: number;
  frequency?: string;
  title: string;
  subheader: string;
  author?: string;
  isSubscribed: boolean;
  isPro: boolean;
}

const EmailSettingsOption = ({
  slug,
  newsletterId,
  frequency,
  title,
  subheader,
  author,
  isSubscribed,
  isPro,
}: EmailSettingOptionProps) => {
  const { currentUser } = useCurrentUser();
  const { mutate: subscribeToNewsletter } = useSubscribeToNewsletter(true);
  const { mutate: unsubscribeFromNewsletter } = useUnsubscribeFromNewsletter(true);
  const { mutate: updateEmailSettings } = useUpdateEmailSettings();

  return (
    <div
      className={clsx(styles.optionContainer, { [styles.articleContainer]: !newsletterId })}
      id={slug}
    >
      <div className={styles.optionWrapper}>
        <div className={styles.frequency}>{frequency}</div>
        <div className={styles.title}>{title}</div>
        {author && author != 'The Information Staff' && (
          <div className={styles.byLine}>by {author}</div>
        )}
        <div className={styles.subheader}>{subheader}</div>
        <div className={clsx(styles.actionContainer, 'action')}>
          {isPro && !currentUser.is_pro_subscriber ? (
            !currentUser.is_subscriber ? (
              <a href={subscribe_path({ offer: PRO_OFFER_CODE })}>Sign up now</a>
            ) : (
              <a href={upgrade_subscription_path()}>Upgrade to Pro</a>
            )
          ) : isSubscribed ? (
            <div
              className={styles.actionWrapper}
              onClick={() =>
                newsletterId
                  ? unsubscribeFromNewsletter({ newsletter_id: newsletterId })
                  : updateEmailSettings({ user: { article_notifications: 'topics' } })
              }
            >
              <img src={getImgxSrc('icons/checkbox_green.svg', true)} alt="Subscribed" />
              <div className={clsx(styles.actionLabel, styles.following)}>Following</div>
            </div>
          ) : (
            <div
              className={styles.actionWrapper}
              onClick={() =>
                newsletterId
                  ? subscribeToNewsletter({ newsletter_id: newsletterId })
                  : updateEmailSettings({ user: { article_notifications: 'all' } })
              }
            >
              <img src={getImgxSrc('icons/small_subscribe.svg', true)} alt="Subscribed" />
              <div className={styles.actionLabel}>Subscribe</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailSettingsOption;
